import React, { useState } from 'react';
import ProductInvestmentDropdown from '../../shared/common-dropdown/ProductInvestmentDropdown';

function EditLead({ LeadData = {}, sendDataToParent }) {
    const [getMobileNumber, setMobileNumber] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.currentTarget;
    sendDataToParent({
      ...LeadData,
      [name]: value
    });

    if(name === "MobileNumber") {
      if (/^\d*$/.test(value)) {
        setMobileNumber(value);
      }else {
        return;
      }
    }

  };

  
     

  const handleDropdownChange = (selectedOptions) => {
    sendDataToParent({
      ...LeadData,
      ClientCompanyTypeIds: selectedOptions ? selectedOptions.map(opt => opt) : [],
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="mb-3">
          <label className="form-label">Client Name<span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            name="ClientName"
            className="form-control"
            value={LeadData.ClientName || ""}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">Mobile No<span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            name="MobileNumber"
            className="form-control"
            value={getMobileNumber || LeadData.MobileNumber || ""}
            onChange={handleChange}
            maxLength="10"
          />
        </div>
      </div>

      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">Email ID<span style={{ color: "red" }}>*</span></label>
          <input
            type="text"
            name="EmailId"
            className="form-control"
            value={LeadData.EmailId || ""}
            onChange={handleChange}
          />
        </div>
      </div>

      {/* ✅ Dropdown with Pre-Selected Values */}
      <div className="col-lg-12">
        <div className="mb-3">
          <label className="form-label">Product Investment<span style={{ color: "red" }}>*</span></label>
          <ProductInvestmentDropdown
            onChangeDropdown={handleDropdownChange}
            selectedValue={LeadData.ClientCompanyTypeIds || []}
            showTitle={false}
          />
        </div>
      </div>

      <div className="col-lg-12">
        <div className="summer-description-box transfer mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="Description"
            rows="3"
            className="form-control"
            value={LeadData.Description || ""}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  );
}

export default EditLead;
